(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-products')) {
    customElements.define(
      'bundle-products',
      class BundleProducts extends HTMLElement {
        connectedCallback() {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const next = data.html.getElementById(this.id)
            if (next) this.innerHTML = next.innerHTML
          })
        }

        disconnectedCallback() {
          this.unsubscribe?.()
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
